import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

interface Data extends SelfServiceAPI.CreateDateAmendmentRequest.Request {
  bookingId: string;
}

const createDateAmendmentRequest = async (
  data: Data,
  options: Options = {},
): Promise<SelfServiceAPI.CreateDateAmendmentRequest.Response> => {
  const { bookingId, ...body } = data;
  try {
    const { data } = await api.post(`/bookings/${bookingId}/date-amendment-request`, body);
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/date-amendment-request`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createDateAmendmentRequest;
